import React from 'react';
import { FormattedText } from 'core/i18n';

export const JointHolderContainer = ({ visibility, handleOnClick, id }) => (
    <div className={visibility ? 'dni-deny' : 'hidden'} id={id}>
        <div className="prospects-gutter prospects-separator-joint-holder">
            <div className="row">
                <div className="col-xs-12">
                    <i className="icons icons--icon-clock-type-2" />
                    <h5 className="font-heading5 dni-deny__title">
                        <FormattedText value="initial-weAreUnable" />
                    </h5>
                    <span className="dash" />
                    <p className="font-paragraph2 dni-deny__description">
                        <FormattedText value="initial-IdentificationDocument" />
                    </p>
                    <p className="font-paragraph2 dni-deny__description">
                        <FormattedText value="initial-IdentificationDocumentParaphOne" />
                    </p>
                    <p className="font-paragraph2 dni-deny__description">
                        <FormattedText value="initial-IdentificationDocumentParaphTwo" />
                    </p>
                    <div>
                        <hr className="dni-deny__hr" />
                        <i className="icons icons--icon-phone-blue" />
                        <p className="font-paragraph2 dni-deny__call-center">
                            <FormattedText value="initial-contactMessageJointHolder" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="row form__footer form__footer-inner">
            <div className="col-xs-12 text-right">
                <button type="button" className="form__button form__button-secondary" onClick={handleOnClick}>
                    <FormattedText value="button-understood" />
                </button>
            </div>
        </div>
    </div>
);
